import React from 'react';
import { Tooltip, TooltipProps } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

type QuestionMarkTooltipProps = TooltipProps & {
  iconSize?: number;
  onClick?: React.MouseEventHandler<HTMLElement>;
};

export const QuestionMarkTooltip: React.FC<QuestionMarkTooltipProps> = ({
  iconSize = 14,
  onClick,
  placement = 'top',
  ...tooltipProps
}) => {
  return (
    <Tooltip placement={placement} {...tooltipProps}>
      <span
        className="question-mark-tooltip-trigger"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1,
          cursor: onClick ? 'pointer' : 'help',
        }}
        onClick={onClick}
        onKeyDown={
          onClick
            ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onClick(event);
                }
              }
            : undefined
        }
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        aria-label={
          typeof tooltipProps.title === 'string'
            ? tooltipProps.title
            : undefined
        }
      >
        <QuestionCircleOutlined
          style={{
            fontSize: iconSize,
            color: 'var(--color-primary, #41aaaf)',
            pointerEvents: 'none',
          }}
        />
      </span>
    </Tooltip>
  );
};
